import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { COOKIE, LOCAL_STORAGE } from '../constants';

export default function useAuthOrRedirect() {
  const [cookies] = useCookies([COOKIE.ACCESS_TOKEN]);
  const [token, setToken] = useState('');
  const router = useRouter();

  useEffect(() => {
    const token = cookies[COOKIE.ACCESS_TOKEN];
    setToken(token);
    if (!token) {
      localStorage.setItem(
        LOCAL_STORAGE.REDIRECT_AFTER_AUTH,
        window.location.href,
      );
      router.push('/login');
    }
  }, [token]);

  return !!token;
}
